<template>
  <v-card elevation="0" class="mb-4 rounded-lg" outlined>
    <v-card-title class="subtitle-1 font-weight-medium pb-1">
      <v-icon left small>mdi-warehouse</v-icon>
      Plans de stock par métier
    </v-card-title>
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate />
      <div v-else-if="error" class="caption error--text">{{ error }}</div>
      <div v-else-if="!rows.length" class="caption grey--text">Aucun métier activé pour cet utilisateur.</div>
      <div v-for="row in rows" :key="row.metier.slug" class="mb-3">
        <div class="body-2 font-weight-medium">{{ row.metier.label }}</div>
        <div class="caption grey--text mb-1">
          En vigueur : {{ row.effective ? row.effective.name : 'aucun plan (non vérifié)' }}
          <span v-if="row.assigned_by"> · assigné par {{ row.assigned_by }}</span>
        </div>
        <div class="d-flex align-center" style="gap: 8px">
          <v-select
            :value="row.assigned ? row.assigned.id : null"
            :items="row.options"
            item-text="name"
            item-value="id"
            label="Plan assigné (automatique si vide)"
            clearable
            dense
            outlined
            hide-details
            :loading="saving === row.metier.slug"
            @change="value => assign(row, value)"
          >
            <template v-slot:item="{ item }">
              {{ item.name }}
              <span class="caption grey--text ml-2">{{ item.owner_label }}</span>
            </template>
          </v-select>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  fetchAdminUserStockPlans,
  setAdminUserStockPlan,
  clearAdminUserStockPlan,
} from '@/services/adminApi'
import { apiErrorMessage } from './stockPlan'

export default {
  name: 'AdminUserStockPlans',
  props: { userId: { type: String, required: true } },
  data: () => ({ rows: [], loading: false, error: null, saving: null }),
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      this.error = null
      try {
        this.rows = await fetchAdminUserStockPlans(this.userId)
      } catch (e) {
        this.error = apiErrorMessage(e)
      } finally {
        this.loading = false
      }
    },
    async assign(row, planId) {
      const slug = row.metier.slug
      this.saving = slug
      try {
        if (planId) await setAdminUserStockPlan(this.userId, slug, planId)
        else await clearAdminUserStockPlan(this.userId, slug)
        this.rows = await fetchAdminUserStockPlans(this.userId)
        this.$store.commit('chat/SHOW_NOTIFICATION', { type: 'success', message: 'Plan de stock enregistré.' })
      } catch (e) {
        this.$store.commit('chat/SHOW_NOTIFICATION', { type: 'error', message: apiErrorMessage(e) })
        await this.load()
      } finally {
        this.saving = null
      }
    },
  },
}
</script>
